var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLabParametersWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 7.16406H18V16.1641C18 19.4778 15.3137 22.1641 12 22.1641V22.1641C8.68629 22.1641 6 19.4778 6 16.1641V7.16406Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 2.16406C4.44772 2.16406 4 2.61178 4 3.16406C4 3.71635 4.44772 4.16406 5 4.16406H6V16.1641C6 19.4778 8.68629 22.1641 12 22.1641C15.3137 22.1641 18 19.4778 18 16.1641V4.16406H19C19.5523 4.16406 20 3.71635 20 3.16406C20 2.61178 19.5523 2.16406 19 2.16406H18H16H8H6H5ZM16 4.16406H8V16.1641C8 18.3732 9.79086 20.1641 12 20.1641C14.2091 20.1641 16 18.3732 16 16.1641V4.16406Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 13.1641C13.5523 13.1641 14 12.7163 14 12.1641C14 11.6118 13.5523 11.1641 13 11.1641C12.4477 11.1641 12 11.6118 12 12.1641C12 12.7163 12.4477 13.1641 13 13.1641ZM11 17.1641C11.5523 17.1641 12 16.7163 12 16.1641C12 15.6118 11.5523 15.1641 11 15.1641C10.4477 15.1641 10 15.6118 10 16.1641C10 16.7163 10.4477 17.1641 11 17.1641Z",
    fill: "#A461D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabParametersWhite);
export default __webpack_public_path__ + "static/media/lab-parameters-white.ff60ffd6199c94e5df826e07b59ee743.svg";
export { ForwardRef as ReactComponent };